__webpack_require__.p = "/reports-manage-location-details/referrals-hub/";